import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { Core } from "../helpers/core";
import { Money } from "../helpers/money";
import { getMyGemService } from "@/services";
import moment from "moment";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";
export default class EstimatesService extends ApiService {
  namespace = "estimate";
  previewNamespace = "invoice";
  template = "defaultTemplate";
  fullWindow = false;
  icon = "CalculatorWithFolder";
  relations =
    "?expand=lineItems,layout,writeoffs,overPayments,headers,footers,messages,journals,overPayments,files,files.file,files.file.commentsCount,customerName,salesRep";
  listingRelations = "customerName";
  DOMAIN = DOMAIN.ESTIMATE;
  data = [];
  showLeftBar = false;
  favicon = "Calculator";
  showLeftBar = false;
  enableSchedular = true;
  useNextNumber = true;
  name = this.terminology.estimates.plural;
  singular = this.terminology.estimates.singular;
  plural = this.terminology.estimates.plural;
  vowel = this.terminology.estimates.vowel;
  labelKey = "number";
  Width = 1500;
  gemItems = [
    {
      key: "listing",
      label: "All Estimates",
      icon: AppIcons.BULLETS,
    },
    {
      key: "create",
      label: "Add an Estimate",
      icon: AppIcons.PLUS,
    },
    {
      key: "create",
      label: "Settings",
      services: -39,
      icon: AppIcons.GEAR,
    },
  ];

  columns = [
    {
      header: this.t("number"),
      icon: AppIcons.SHRED,
      field: "number",
      sortable: true,
      width: "7",
    },
    {
      header: this.t("customer"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "customer",
      width: "10",
      template: (data) =>
        data.customer?.display_name ?? data.customerName ?? "",
    },
    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      sortable: true,
      width: "7",
      template: (data) => {
        return Core.datey(data.date);
      },
    },

    {
      header: this.t("amount"),
      icon: AppIcons.MONEY,
      field: "total_amount",
      sortable: true,
      width: "7",
      template: (data) => Money.format(data.total_amount),
    },

    {
      header: this.t("status"),
      icon: AppIcons.LIGHTNING,
      field: "status",
      width: "8",
      statusIndicator: true,
    },
  ];
  lineItems = [
    {
      key: "edit",
      label: "Apply Subtotal",
      icon: PrimeIcons.PENCIL,
    },
    {
      key: "announce",
      label: "Bank Line",

      icon: PrimeIcons.LIST,
    },
    {
      key: "email",
      label: "Discount",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "bookmark",
      label: "Good",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Inventory Item",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Other Change",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Over Payment",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Service",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Tax",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      separator: true,
    },
    {
      key: "inactive",
      label: "Time & Expenses",
      icon: PrimeIcons.LOCK,
    },
  ];
  moreItems = [
    {
      key: "create",
      label: "Load template",
      icon: AppIcons.FOLDER,
      type: "1",
    },
    {
      key: "create",
      label: "Save and preview",
      icon: AppIcons.PREVIEW,
      type: "2",
    },
    {
      key: "create",
      label: "Save and print",
      icon: AppIcons.PRINTER,
      type: "3",
    },
    {
      key: "create",
      label: "Save and e-mail",
      icon: AppIcons.MAIL,
      type: "4",
    },
    {
      key: "create",
      label: "Manage layout",
      icon: AppIcons.LAYOUT,
      type: "5",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: DOMAIN.VENDOR,
      icon: AppIcons.DISABLE,
    },
  ];
  getActionMenu(item) {
    const entity = this.singular;
    return [
      {
        key: "detail",
        label: this.t("previewThisEntity", { entity }),
        icon: "Eye",
      },
      {
        key: "edit",
        label: this.t("editThisEntity", { entity }),
        icon: AppIcons.EDIT,
      },
      {
        key: "announce",
        label: this.t("announceThisEntity", { entity }),
        services: DOMAIN.MESSAGES,
        icon: AppIcons.ANNOUNCEMENT,
      },
      {
        key: "email",
        label: this.t("emailThisEntity", { entity }),
        icon: AppIcons.MAIL,
        services: DOMAIN.EMAIL,
      },
      {
        key: "bookmark",
        label: this.t("bookmarkThisEntity", { entity }),
        icon: AppIcons.BOOKMARK,
      },
    ];
  }
  listMenuItems = [
    {
      key: "edit",
      label: this.t("editThisEntity", { entity: this.singular }),
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: this.t("announceThisEntity", { entity: this.singular }),
      services: DOMAIN.MESSAGES,
      icon: AppIcons.ANNOUNCEMENT,
    },
    {
      key: "email",
      label: this.t("emailThisEntity", { entity: this.singular }),
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: this.t("bookmarkThisEntity", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "create",
      label: this.t("copyThisEntity", { entity: this.singular }),
      icon: AppIcons.COPY,
      serviceId: DOMAIN.COPY_PAYABLES,
    },
    {
      key: "exec",
      label: this.t("printThisEntity", { entity: this.singular }),
      icon: AppIcons.PRINTER,
      action: (item, ctx) => {
        ctx.$emit("print", item);
      },
    },
  ];
  permissions = [
    {
      key: "is_template",
      display_name: "Template",
      icon: AppIcons.TEMPLATE,
      value: 1,
    },
    {
      key: "is_draft",
      display_name: "Draft",
      icon: AppIcons.DOCUMENT_WITH_TEXT,
      value: 1,
    },
    {
      key: "is_tba",
      display_name: "Waiting Approval",
      icon: AppIcons.TICK,
      value: 1,
    },
    {
      key: "status",
      display_name: "Completed",
      icon: AppIcons.MONEY,
      value: 1,
    },
    {
      key: "is_in_print_que",
      display_name: "Print Que",
      icon: AppIcons.FAX,
      value: 1,
    },
    {
      key: "is_in_email_que",
      display_name: "Email Que",
      icon: AppIcons.MAIL,
      value: 1,
    },
  ];
  filterItems = [
    { name: "Status", key: "status", value: "2", realm: "2" },
    { name: "Date", key: "date", value: "3", realm: "1" },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Estimate",
      icon: AppIcons.LIST,
    },
  ];

  constructor() {
    super("estimates");
  }
}
